import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import SlsRtnProcessActions from '../../Stores/SlsRtnProcess/Actions';

import SlsOrdFServ01Form from '../SlsOrdFServ01/SlsOrdFServ01Form';
import SlsRtnSync01Form from '../SlsRtnSync01/SlsRtnSync01Form';
import InbOrd02Table from '../InbOrd02/InbOrd02Table';
import RtnRcptSync01Table from '../RtnRcptSync01/RtnRcptSync01Table';
import SlsRtnFServ02Table from '../SlsRtnFServ02/SlsRtnFServ02Table';
import GdsRcptFServ03Table from '../GdsRcptFServ03/GdsRcptFServ03Table';

const { TabPane } = Tabs;

class SlsRtnProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curDivisionId, fetchSlsRtnProcess } = this.props;

    if (curDivisionId > 0) {
      fetchSlsRtnProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curDivisionId, fetchSlsRtnProcess } = this.props;
    const { changed } = treeChanges(prevProps, this.props);
    if (changed('curDivisionId')) {
      if (curDivisionId > 0) {
        fetchSlsRtnProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/slsRtnProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'SLS_ORD_F_SERV_01' && <SlsOrdFServ01Form match={match} />}
        {match.params.proc_type === 'SLS_RTN_SYNC_01' && <SlsRtnSync01Form match={match} />}
        {match.params.proc_type === 'INB_ORD_02' && <InbOrd02Table match={match} />}
        {match.params.proc_type === 'RTN_RCPT_SYNC_01' && <RtnRcptSync01Table match={match} />}
        {match.params.proc_type === 'SLS_RTN_F_SERV_02' && <SlsRtnFServ02Table match={match} />}
        {match.params.proc_type === 'GDS_RCPT_F_SERV_03' && <GdsRcptFServ03Table match={match} />}
      </Card>
    );
  }
}

SlsRtnProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curDivisionId: PropTypes.number,
  fetchSlsRtnProcess: PropTypes.func
};

SlsRtnProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curDivisionId: 0,
  fetchSlsRtnProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.slsRtnProcess.process,
  processIsLoading: state.slsRtnProcess.processIsLoading,

  curDivisionId: state.app.curDivisionId
});

const mapDispatchToProps = dispatch => ({
  fetchSlsRtnProcess: () => dispatch(SlsRtnProcessActions.slsRtnProcessFetchSlsRtnProcess())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SlsRtnProcessScreen));
